import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 3 2", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#007E3A", d: "M0 0h3v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FC3D32", d: "M0 0h3v1H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h1v2H0z" }));
const ForwardRef = forwardRef(SvgMg);
const Memo = memo(ForwardRef);
export default Memo;
